import {Component, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormGroup} from '@angular/forms';
import {ConfirmDialogComponent} from '../../dialog/confirm-dialog/confirm-dialog.component';
import {TimePeriod} from '../../../classes/TimePeriod';
import {TimePeriodService} from '../../../services/time-period.service';
import {TimeperiodEditComponent} from '../timeperiod-edit/timeperiod-edit.component';

@Component({
  selector: 'app-timeperiod-list',
  styleUrls: ['./timeperiod-list.component.scss'],
  templateUrl: './timeperiod-list.component.html',
})
export class TimeperiodListComponent implements OnInit {

  public timePeriods: TimePeriod[];
  public errorMessage: string;
  private currentDialog = null;

  constructor(private timePeriodService: TimePeriodService,
              private modalService: NgbModal) {}

  ngOnInit(): void {
    this.updateList();
  }

  updateList(): void {
    this.timePeriodService.getAll().subscribe({
      next: (timePeriods) => {
        this.timePeriods = timePeriods;
      },
      error: (error) => this.errorMessage = error.error.error
    });
  }

  openEditModal(timePeriod: TimePeriod): void {
    this.currentDialog = this.modalService.open(TimeperiodEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-timeperiod-edit',
        size: 'lg',
        centered: true,
      });

    this.currentDialog.componentInstance.timePeriod = timePeriod;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {
          const editedTimePeriod = new TimePeriod(result.value);

          this.timePeriodService.addOrEdit(editedTimePeriod).subscribe({
            next: () => this.updateList(),
            error: (error) => this.errorMessage = error.error.error
          });
        }
      },
      (error) => { console.log('Dialog close error: ' + error); }
    );
  }

  openDeleteConfirmModal(timePeriod: TimePeriod): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-timeperiod-delete-confirm',
        size: 'md',
        centered: true,
        // keyboard: false,
        // backdrop: 'static'
      });

    this.currentDialog.componentInstance.message =
      'Are you sure that you want to delete time period with id ' + timePeriod.id + '?';

    this.currentDialog.result.then((result) => {
      if (result.status === 'confirmed') {
        this.timePeriodService.delete(timePeriod.id).subscribe({
          next: () => this.updateList(),
          error: (error) => this.errorMessage = error.error.error
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }

}
